import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Person"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M13.5 22.5H10.5C9.67157 22.5 9 21.8284 9 21V15.75C8.17157 15.75 7.5 15.0784 7.5 14.25V9.75C7.5 8.50736 8.50736 7.5 9.75 7.5H14.25C15.4926 7.5 16.5 8.50736 16.5 9.75V14.25C16.5 15.0784 15.8284 15.75 15 15.75V21C15 21.8284 14.3284 22.5 13.5 22.5ZM9.74998 8.99998C9.54725 8.98656 9.34859 9.06126 9.20493 9.20493C9.06126 9.34859 8.98656 9.54725 8.99998 9.74998V14.25H10.5V21H13.5V14.25H15V9.74998C15.0134 9.54725 14.9387 9.34859 14.795 9.20493C14.6514 9.06126 14.4527 8.98656 14.25 8.99998H9.74998ZM12 6.75C10.3431 6.75 9 5.40685 9 3.75C9 2.09315 10.3431 0.75 12 0.75C13.6569 0.75 15 2.09315 15 3.75C15 4.54565 14.6839 5.30871 14.1213 5.87132C13.5587 6.43393 12.7956 6.75 12 6.75ZM12 2.25C11.1716 2.25 10.5 2.92157 10.5 3.75C10.5 4.57843 11.1716 5.25 12 5.25C12.8284 5.25 13.5 4.57843 13.5 3.75C13.5 2.92157 12.8284 2.25 12 2.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Person.vue"]]);
